<template>
  <div v-if="user">
    <chat-user
      :user="user"
      :status="value"
    />
    <select
      :value="value"
      @input="handleChangeStatus"
    >
      <option value="offline">
        Offline
      </option>
      <option value="online">
        Online
      </option>
      <option value="away">
        Away
      </option>
    </select>
  </div>
</template>

<script>
import ChatUser from './ChatUser';

export default {
  name: 'ChatStatus',
  components: {
    ChatUser,
  },
  props: {
    user: { type: Object, required: true },
    value: { type: String, required: true },
  },
  methods: {
    async handleChangeStatus(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>
